import { useState } from "react";
import ModuleHeader from "../../components/ModuleHeader";
import OverallTab from "./OverallTab";
import PartnersInfoTab from "./PartnersInfoTab";
import SummaryTab from "./SummaryTab";
import PerformanceTab from "./PerformanceTab";
import { BANNER_TITLES, DASHBOARD_TABS } from "./constants";
import "./Dashboard.css";

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState("overall");

  const renderTab = () => {
    switch (activeTab) {
      case "overall":
        return <OverallTab />;
      case "partners-info":
        return <PartnersInfoTab />;
      case "summary":
        return <SummaryTab />;
      case "performance":
        return <PerformanceTab />;
      default:
        return null;
    }
  };

  return (
    <div className="dashboard-page">
      <ModuleHeader
        title={BANNER_TITLES[activeTab] || "Dashboard & Overview"}
        tabs={DASHBOARD_TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        showBack={false}
      />
      {renderTab()}
    </div>
  );
}
